import { createAsyncThunk } from "@reduxjs/toolkit";
import { post } from "helpers/api_helper";
import {
  GET_DASHBOARD_BOOKING_DETAILS,
  GET_OVERVIEW_COMPARISON_CHART,
  GET_OVERVIEW_DASHBOARD_24_7_CHART,
  GET_OVERVIEW_DASHBOARD_CHART_DETAILS,
  GET_OVERVIEW_DASHBOARD_DETAILS,
  GET_OVERVIEW_DASHBOARD_SPACE_DETAILS,
  GET_RATING_DASHBOARD_DETAILS,
  GET_RATING_HISTORY,
  RATING_HISTORY_EXPORT,
} from "helpers/url_helper";

export const getRatingDashboardDetails = createAsyncThunk(
  GET_RATING_DASHBOARD_DETAILS,
  async (payload) => {
    const response = await post(GET_RATING_DASHBOARD_DETAILS, payload);
    return response;
  }
);

export const getDashboardRatingHistory = createAsyncThunk(
  GET_RATING_HISTORY,
  async (payload) => {
    const response = await post(GET_RATING_HISTORY, payload);
    return response;
  }
);

export const getOverviewDashboardDetails = createAsyncThunk(
  GET_OVERVIEW_DASHBOARD_DETAILS,
  async (payload) => {
    const response = await post(GET_OVERVIEW_DASHBOARD_DETAILS, payload);
    return response;
  }
);

export const getOverviewDashboardSpaceDetails = createAsyncThunk(
  GET_OVERVIEW_DASHBOARD_SPACE_DETAILS,
  async (payload) => {
    const response = await post(GET_OVERVIEW_DASHBOARD_SPACE_DETAILS, payload);
    return response;
  }
);

export const getOverviewDashboard24_7_Chart = createAsyncThunk(
  GET_OVERVIEW_DASHBOARD_24_7_CHART,
  async (payload) => {
    const response = await post(GET_OVERVIEW_DASHBOARD_24_7_CHART, payload);
    return response;
  }
);

export const getDashboardBookingDetails = createAsyncThunk(
  GET_DASHBOARD_BOOKING_DETAILS,
  async (payload) => {
    const response = await post(GET_DASHBOARD_BOOKING_DETAILS, payload);
    return response;
  }
);

export const ratingDashboardHistory = createAsyncThunk(
  RATING_HISTORY_EXPORT,
  async (payload) => {
    const response = await post(RATING_HISTORY_EXPORT, payload);
    return response;
  }
);

export const getOverviewDashboardChartDetails = createAsyncThunk(
  GET_OVERVIEW_DASHBOARD_CHART_DETAILS,
  async (payload) => {
    const response = await post(GET_OVERVIEW_DASHBOARD_CHART_DETAILS, payload);
    return response;
  }
);

export const getOverviewComparisonChart = createAsyncThunk(
  GET_OVERVIEW_COMPARISON_CHART,
  async (payload) => {
    const response = await post(GET_OVERVIEW_COMPARISON_CHART, payload);
    return response;
  }
);
